<template>
  <div class="product-list-container">
    <div class="header">
      <search-input
        placeholder="Search for keyword"
        v-model="search"
        @keyup.native="GetList"
        class="search-input"
      />
      <primary-button
        @click.native="$router.push({name: 'company-admin-campaings-add-keyword'})"
        class="primary-button"
      >Add Keyword</primary-button>
    </div>
    <div v-if="KeywordList.length > 0" class="table table-header">
      <div class="first-col"></div>
      <div class="second-col">Campaign Name</div>
      <div class="third-col">Type</div>

      <div class="twelfth-col"></div>
    </div>
    <div v-for="(keyword, k) in KeywordList" :key="k" class="table table-body">
      <div class="first-col">
        <div
          class="status"
          :class="{'running': keyword.status === 'running', 'hold': keyword.status === 'hold', 'stop': keyword.status === 'stop'}"
        ></div>
      </div>
      <div class="second-col">{{keyword.keyword}}</div>
      <div class="third-col">{{keyword.description}}</div>

      <div class="twelfth-col">
        <div class="edit-container">
          <img
            @click="$router.push({name: 'company-admin-campaings-edit-keyword', params: {id: keyword.keyword_uuid}})"
            src="@/assets/Icon/Edit.svg"
            alt
          />
          <img @click="showAlert(keyword.keyword_uuid)" src="@/assets/Icon/Delete.svg" alt />
        </div>
      </div>
    </div>
    <pagination-component
      @change-page="changePage($event)"
      :page="Page"
      :perPage="per_page"
      :total="TotalPages"
      :qnt="KeywordList.length"
    />
  </div>
</template>

<script>
export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    CardComponent: () => import("@/components/CardComponent.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  data: () => ({
    KeywordList: [],
    Page: 0,
    search: "",
    TotalPages: null
  }),
  methods: {
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    GetList() {
      this.$store
        .dispatch("GetKeywordList", {
          page: this.Page,
          keyword: this.search
        })
        .then(res => {
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.KeywordList = res.items;
        });
    },

    showAlert(campaign_uuid) {
      // Use sweetalert2
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this campaign!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteKeyword", campaign_uuid)
            .then(() => {
              this.GetList();
              this.$swal(
                "Deleted!",
                "Your campaign has been deleted.",
                "success"
              );
            })
            .catch(err => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    }
  },
  created() {
    this.GetList();
  }
};
</script>

<style lang="scss" scoped>
.product-list-container {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin: 20px 0 10px 0;
    .search-input {
      max-width: 345px;
      height: 100%;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 130px;
    }
  }
  .table {
    width: 100%;
    min-width: 851px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .first-col {
      max-width: 33px;
      width: 3%;
      display: flex;
      justify-content: center;
      .status {
        height: 10px;
        width: 10px;
        border-radius: 50%;
      }
      .running {
        background-color: #24e2b8;
      }
      .stop {
        background-color: #d2305b;
      }
      .hold {
        background-color: #ffc941;
      }
    }
    .second-col {
      width: 30%;
    }
    .third-col {
      width: 55%;
    }

    .twelfth-col {
      width: 12%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      svg {
        cursor: pointer;
      }
      .running {
        fill: #24e2b8;
      }
      .stop {
        fill: #d2305b;
      }
      .hold {
        fill: #ffc941;
        margin-right: 5px;
      }
      .edit-container {
        height: 100%;
        display: flex;
        align-items: center;
        img {
          cursor: pointer;
          margin-right: 15px;
        }
      }
    }
  }
  .table-header {
    height: 37px;
    color: #212b36;
    font-family: "Helvetica Neue";
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    margin-bottom: 0;
  }
  .table-body {
    height: 44px;
    border-radius: 4px 4px 0 0;
    background-color: #ffffff;
    box-shadow: inset 0 -1px 0 0 #f0f1fa;
    color: #212b36;
    font-family: "Helvetica Neue";
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
  }
}
</style>

